/**
 * MAP (in-file navigation graph — any LLM reads this without external tooling;
 * keep in sync with the code):
 *   role:      component (voucher value/selection display within a voucher list row)
 *   extends:   Component (@glimmer/component)
 *   template:  voucher-list-value.hbs
 *   args:      - (no this.args.* read in JS; see voucher-list-value.hbs for template-level args)
 *   uses:      -
 *   siblings:  voucher-list.hbs, voucher-item.hbs, voucher-msg.hbs
 *   tests:     voucher-list-value-test.js, ui-components-test.js, list-components-test.js
 */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

export default class VoucherListValueComponent extends Component {
  @tracked selectVoucher = null;
}
